import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';
import type { TypeLinkSkeleton } from './TypeLink';
import type { TypeMediaSkeleton } from './TypeMedia';
import type { TypeSectionBackgroundSkeleton } from './TypeSectionBackground';
import type { TypeSliderSkeleton } from './TypeSlider';

export interface TypeHeroSectionFields {
  internalName: EntryFieldTypes.Symbol;
  heading: EntryFieldTypes.Symbol;
  description?: EntryFieldTypes.RichText;
  headingShort?: EntryFieldTypes.Symbol;
  descriptionShort?: EntryFieldTypes.RichText;
  buttonLinks?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeLinkSkeleton>>;
  heroImage?: EntryFieldTypes.AssetLink;
  background?: EntryFieldTypes.EntryLink<TypeSectionBackgroundSkeleton>;
  media?: EntryFieldTypes.EntryLink<TypeMediaSkeleton>;
  slider?: EntryFieldTypes.EntryLink<TypeSliderSkeleton>;
}

export type TypeHeroSectionSkeleton = EntrySkeletonType<TypeHeroSectionFields, 'heroSection'>;
export type TypeHeroSection<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeHeroSectionSkeleton, Modifiers, Locales>;

export function isTypeHeroSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>,
): entry is TypeHeroSection<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'heroSection';
}
